/* eslint-disable jsx-a11y/anchor-is-valid,no-script-url */
import * as React from "react";
import { PropertyTabNames } from "./props";

export interface CustomProps {
  tabName: PropertyTabNames;
  tabChangeHandler: (tabName: PropertyTabNames) => void;
  shortListedCount?: number;
}

const PropertyTabs: React.FunctionComponent<CustomProps> = (props) => {
  const [tabName, setTabName] = React.useState<PropertyTabNames>(
    props.tabName || PropertyTabNames.SearchProperty
  );
  const setElementActive = (tabValue: PropertyTabNames) => {
    setTabName(tabValue);
    props.tabChangeHandler(tabValue);
  };

  React.useEffect(() => {
    if (props.tabName) {
      setTabName(props.tabName);
    }
  }, [props.tabName]);

  return (
    <ul
      className="nav tab-underline mb-3 border-bottom font-sm font-weight-semibold flex-nowrap text-nowrap overflow-auto px-md-0 px-3 w-100"
      id="activity-tab"
      role="tablist"
    >
      <li className="nav-item pr-4" role="presentation">
        <a
          className={`cursor-pointer nav-link position-relative px-0 py-2  ${
            tabName === PropertyTabNames.SearchProperty
              ? "active"
              : "text-gray-600"
          }`}
          onClick={(e) => setElementActive(PropertyTabNames.SearchProperty)}
        >
          <span className=" py-1 d-inline-flex">Search Property</span>
        </a>
      </li>

      <li className="nav-item pr-4" role="presentation">
        <a
          className={`cursor-pointer nav-link position-relative px-0 py-2  ${
            tabName === PropertyTabNames.ShortListedProperty
              ? "active"
              : "text-gray-600"
          }`}
          onClick={(e) =>
            setElementActive(PropertyTabNames.ShortListedProperty)
          }
        >
          <span className=" py-1 d-inline-flex">
            Short Listed Property{" "}
            {!!props.shortListedCount && <>({props.shortListedCount})</>}
          </span>
        </a>
      </li>
      <li className="nav-item pr-4" role="presentation">
        <a
          className={`cursor-pointer nav-link position-relative px-0 py-2  ${
            tabName === PropertyTabNames.Log ? "active" : "text-gray-600"
          }`}
          onClick={(e) => setElementActive(PropertyTabNames.Log)}
        >
          <span className=" py-1 d-inline-flex">Log </span>
        </a>
      </li>
    </ul>
  );
};

export default PropertyTabs;
